<template>
  <div class="min-h-screen bg-[#0F0F0F] text-white px-4 py-10">
    <UiAlert v-model="showAlert" :alert="alertData" :auto-close="true" />

    <div
      class="max-w-4xl mx-auto bg-[#1F1F1F] rounded-2xl shadow-xl p-6 md:p-10"
    >
      <h1 class="text-3xl font-bold mb-6 text-center">
        {{ $t("contact.title") }}
      </h1>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Form -->
        <form class="space-y-4" @submit.prevent="submitForm">
          <input
            v-model="form.name"
            type="text"
            :placeholder="$t('contact.name')"
            class="input"
          />
          <input
            v-model="form.email"
            type="email"
            :placeholder="$t('contact.email')"
            class="input"
          />
          <input
            v-model="form.subject"
            type="text"
            :placeholder="$t('contact.subject')"
            class="input"
          />
          <textarea
            v-model="form.message"
            :placeholder="$t('contact.message')"
            rows="4"
            class="input resize-none"
          />

          <button
            type="submit"
            :disabled="loading"
            class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-md transition disabled:opacity-50"
          >
            {{ loading ? $t("contact.sending") : $t("contact.send") }}
          </button>
        </form>

        <!-- Info -->
        <div class="space-y-4 text-sm text-gray-300">
          <div>
            <p class="font-semibold text-white">
              {{ $t("contact.info.email") }}
            </p>
            <p>info@mem22.com</p>
          </div>
          <div>
            <p class="font-semibold text-white">
              {{ $t("contact.info.phone") }}
            </p>
            <p>+90 510 223 30 22</p>
          </div>
          <div>
            <p class="font-semibold text-white">
              {{ $t("contact.info.address") }}
            </p>
            <p>İznik / Bursa / Türkiye</p>
          </div>
          <div class="pt-6">
            <p class="font-semibold text-white mb-2">
              {{ $t("contact.social") }}
            </p>
            <div class="flex gap-4 text-xl">
              <a
                href="https://www.instagram.com/mem22_official"
                target="_blank"
                rel="noopener"
                class="hover:opacity-80"
              >
                <img
                  src="assets/images/instagram.svg"
                  alt="Instagram"
                  class="w-6 h-6"
                />
              </a>
              <a href="mailto:info@mem22.com" class="hover:opacity-80">
                <img
                  src="assets/images/envelope.svg"
                  alt="E-posta"
                  class="w-6 h-6"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useSupabaseClient, useI18n } from "#imports";
import UiAlert from "@/components/ui/UiAlert.vue";

const supabase = useSupabaseClient();
const { t } = useI18n();
const form = ref({
  name: "",
  email: "",
  subject: "",
  message: "",
});
const loading = ref(false);

// UiAlert state
const showAlert = ref(false);
const alertData = ref({
  message: "",
  type: "info" as "success" | "error" | "warning" | "info",
  icon: "mdi:alert-circle",
});

const notify = (
  message: string,
  type: "success" | "error" | "warning" | "info" = "info",
  icon = "mdi:alert-circle"
) => {
  alertData.value = { message, type, icon };
  showAlert.value = true;
};

const submitForm = async () => {
  if (!form.value.name || !form.value.email || !form.value.message) {
    notify(t("contact.missing"), "warning");
    return;
  }

  loading.value = true;
  try {
    const { error } = await supabase.from("contact_messages").insert({
      name: form.value.name,
      email: form.value.email,
      subject: form.value.subject,
      message: form.value.message,
    });

    if (error) throw error;

    notify(t("contact.success"), "success", "mdi:check-circle");
    form.value = { name: "", email: "", subject: "", message: "" };
  } catch (err) {
    console.error(err);
    notify(t("contact.error"), "error", "mdi:alert-circle-outline");
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.input {
  @apply w-full px-4 py-3 rounded-md border border-gray-600 bg-[#2A2A2A] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500;
}
</style>
